import { Checkbox, TextField } from "@material-ui/core";
import { CheckBox } from "@mui/icons-material";

import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import Table from "../../components/table/Table";
import { fetchAllProduct } from "../../redux/features/product.features";
import LabelPrinting from "./LabelPrinting";
import LabelPrintingLayout from "./LabelPrintingLayout";

const PrintAvailableItem = () => {
  let dispatch = useDispatch();

  //   useEffect(() => {
  //     dispatch(fetchAllProduct());
  //   }, [dispatch]);

  let productState = useSelector((state) => {
    return state.productReducer;
  });

  let { products } = productState;
  const exportCategoryNameList=["Ruby", "Blue Sapphire", "Green Sapphire", "Peach Sapphire", "Mix Sapphire", "Star Sapphire", "Padparadscha", "TSavorite", "Spinel", "Tourmaline", "Alexandrite", "Aquamarine", "Cats eye", "Garnet", "Precious", "Semi Precious"]

  const [filteredProducts, setfilteredProducts] = useState([]);
  const [exportCategoryWiseProducts, setexportCategoryWiseProducts] = useState([]);
  const [checkALL, setCheckedAll] = useState(true);
  const [sumOfPiece, setSumOfPiece] = useState(0);
  const [sumOfBuyPrice, setSumOfBuyPrice] = useState(0);
  const [sumOfCarat, setsumOfCarat] = useState(0);
  let componentRef = useRef();
  let labelPrintRef = useRef();

 

  useEffect(() => {
    let filteredPro = JSON.parse(
      JSON.stringify(products.filter((x) => !x.isSold))
    );

    console.log("pp", filteredPro)
    filteredPro.map((x, i) => {
      x.check = true;
      x.no = i + 1;
    });

    let sum = 0;
    //calculate sum of buyPiece
    filteredPro.map((x) =>
      x.buyPiece ? (sum = sum + Number(x.buyPiece)) : sum++
    );
    setSumOfPiece(sum);
    setfilteredProducts(filteredPro);

    let exportCategoryLists = filteredPro.filter(x=>{

      console.log(x.exportMainCategory)
      return exportCategoryNameList.includes(x.exportMainCategory)
    })
    console.log("export names", exportCategoryLists)
    console.log("export names filteredProdus", filteredPro)
    setexportCategoryWiseProducts(exportCategoryLists)
  }, []);

  useEffect(() => {
    let sum = 0;
    let sumBuyPrice = 0;
    let sumOfCarat = 0;
    //calculate sum of buyPiece
    filteredProducts.map((x) =>
      x.buyPiece ? (sum = sum + Number(x.buyPiece)) : sum++
    );
    filteredProducts.map((x) =>
      x.buyPrice ? (sumBuyPrice = sumBuyPrice + Number(x.buyPrice)) : ""
    );
    filteredProducts.map((x) =>
      x.weight ? (sumOfCarat = sumOfCarat + Number(x.weight)) : ""
    );
    setSumOfPiece(sum);
    setSumOfBuyPrice(sumBuyPrice);
    setsumOfCarat(sumOfCarat);

   

  }, [filteredProducts]);

  const allItemTableHead = [
    "checkbox",
    "No",
    "title",
    "ID",
    "Pcs",
    "N/H",
    // "category",
    "Carat", //weight
    "origin",
    // "shape",
    "buying",
    "estimated",
    "sold",
    "Buyer",
    "Remark",
  ];

  const finalRenderBody = (item, index) => (
    <tr
      className="text-sm font-extrabold"
      style={{ color: "var(--txt-color)" }}
      key={index}
    >
      <td className="checkbox" style={{ width: 10 }}>
        <Checkbox
          onChange={(e) => checkItem(item.productId, e.target.checked)}
          checked={item.check || false}
        ></Checkbox>
      </td>

      <td className="no">{index + 1}</td>
      <td>{item.title}</td>
      <td className="id">{item.productId}</td>
      {/* <td>{item.category}</td> */}
      {/* <td>{item.description}</td> */}
      {/* <td>{item.date}</td> */}
      {/* <td>{item.clarity}</td> */}
      {/* <td>{item.need_recut}</td> */}
      <td>{item.buyPiece || 1}</td>
      <td className="id">
        {item.treatment_type === "Natural"
          ? "N"
          : item.treatment_type === "Heated"
          ? "H"
          : item.treatment_type}
      </td>
      <td className="id">{item.weight}</td>
      <td>{item.origin}</td>
      {/* <td>{item.shape}</td> */}
      {/* <td>{item.dimension}</td> */}
      <td className="text-right">
        <span>{Number(item.buyPrice).toLocaleString()}</span>{" "}
        <span style={{ width: 35 }} className="">
          {item.buyCurrency}
        </span>
      </td>
      {/* <td className="text-right">
        <span>{Number(item.sellPriceLocal).toLocaleString()}</span>{" "}
        <span style={{ width: 35 }} className="">
          {item.sellLocalCurrency}
        </span>
      </td> */}

      <td className="text-right">
        <span>{Number(item.sellPriceForeigners).toLocaleString()}</span>{" "}
        <span style={{ width: 35 }} className="">
          {item.sellForeignersCurrency}
        </span>
      </td>
      {/* <td>{item.supplier[0]?.firstName || ""}</td> */}
      <td style={{ width: 120 }}></td>
      <td style={{ width: 120 }}></td>
      <td style={{ width: 120 }}></td>
    </tr>
  );

  const [checked, setChecked] = React.useState(true);

  const handleChange = (event) => {
    setChecked(event.target.checked);

    checkAll(event.target.checked);
  };

  const checkAll = (value) => {
    // setCheckedAll(value)
    console.log("checked all");
    let filteredPro = JSON.parse(
      JSON.stringify(products.filter((x) => !x.isSold))
    );
    filteredPro.map((x) => (x.check = value));

    filteredPro.map((x, i) => {
      x.check = value;
      x.no = i + 1;
    });
    console.log("inside checkall", filteredPro);

    setfilteredProducts(filteredPro);
  };
  const unCheckALL = () => {
    let filteredPro = JSON.parse(
      JSON.stringify(products.filter((x) => !x.isSold))
    ).map((x) => (x.check ? false : true));

    filteredPro.map((x, i) => {
      x.no = i + 1;
    });

    // filteredPro.check = false
    setfilteredProducts(filteredPro);
  };

  const checkItem = (id, value) => {
    let filteredPro = filteredProducts.map((x) => {
      if (x.productId === id) x.check = value;

      return x;
    });
    // filteredPro.check = true
    console.log("item checked", filteredPro);

    setfilteredProducts(filteredPro);
  };
  const uncheckItem = (index) => {
    alert("uncheked " + index);
  };

  const renderHead = (item, index) => (
    <th
      style={{
        width: item === "checkbox" ? 10 : 120,
        minWidth: item === "Carat" ? 10 : "120px !important",
      }}
      className={
        item === "checkbox"
          ? "checkbox"
          : item === "No"
          ? "no"
          : item === "ID"
          ? "id"
          : item === "N/H" || item === "Carat"
          ? "id"
          : ""
      }
      key={index}
    >
      {item === "checkbox" ? (
        <Checkbox
          checked={checked}
          onChange={handleChange}
          inputProps={{ "aria-label": "controlled" }}
        />
      ) : (
        item
      )}
    </th>
  );

  const print = useReactToPrint({
    pageStyle: `  
    @media print{
        ::-webkit-scrollbar {
            display: none;
          }
.checkbox{
  display:none;
}

.pagebreak {
   
  min-height: 1px;
  page-break-before: always;
}

.no{
  width:10px !important
}
.id{
  width:30px !important
}
        div{
        color: black !important;
    }    
        table{
            color: black !important;
            padding-left: 50px !important;
            padding-right: 50px !important;
        }
        thead {
            background-color: black !important;
            color:white;

        }
        td{
padding:3px !important;
border: 1px solid black;
width:120px;
color:black !important;
        }
        th{
          padding: 4px 16px !important;
        }
            
      @page {
          margin: 10px;
          margin-bottom: 10px;
          size: A3;
          
           }
      body{
        -webkit-print-color-adjust: exact;
          font-size:9px;
          color:#000 !important;
        
      }
      section{
      
      background-color: white;
  }
  
  h1{
      font-size: 10px;
      
  }
  p{
      font-size: 9px;
  }
  table{
    width:100%;
    font-size: 10px;
  }
  td{
    font-size: 10px;
  }
  }
    `, // remove date/time from top

    // pageStyle:"@page { size: 8-1/4in 11-3/4in }",
    content: () => componentRef.current,
  });
  const printLabel = useReactToPrint({
    pageStyle: `  
    @media print{
        ::-webkit-scrollbar {
            display: none;
          } 
      body{
        -webkit-print-color-adjust: exact; 
        width: 17.5cm;
        height: 24cm;
      }
      
  
  
  }
    `, // remove date/time from top

    // pageStyle:"@page { size: 8-1/4in 11-3/4in }",
    content: () => labelPrintRef.current,
  });

  function setPageSize(cssPageSize) {
    const style = document.createElement("style");
    style.innerHTML = `@page {  margin: 30px; size: ${cssPageSize}`;
    style.id = "page-orientation";
    document.head.appendChild(style);
  }
  function setLabelPageSize(cssPageSize, margin) {
    const style = document.createElement("style");
    style.innerHTML = `@page { size: 21cm 29.7cm; 
       margin:0;
       margin-top:1mm !important;
       margin-left:4mm !important;
      }
      .pageBreak{
        page-break-before: always;
      }
     
      `;
    style.id = "page-orientation";
    document.head.appendChild(style);
  }
  const [orientation, setOrientation] = useState("landscape"); //landscape
  useEffect(() => {
    setPageSize(orientation);
    return () => {
      const child = document.getElementById("page-orientation");
      child.parentNode.removeChild(child);
    };
  }, [orientation]);

  const printSelectedItems = () => {
    setPageSize("landscape");
    setfilteredProducts(filteredProducts.filter((x) => x.check));
    setTimeout(() => {
      print();
    }, 1000);
  };
  const [unselectedIds, setunselectedIds] = useState();

  const unselectIds = () => {
    var ids = unselectedIds;
    if (ids !== "") {
      let searchIds = ids.split(",").map((x) => x.trim());

      let filteredPro = filteredProducts.map((x) => {
        if (searchIds.includes(x.productId)) x.check = false;
        return x;
      });
      // filteredPro.check = true
      console.log("item un checked bulk", filteredPro);

      setfilteredProducts(filteredPro);
    }
  };
  const [selectedIds, setselectedIds] = useState();

  const selectIds = () => {
    var ids = selectedIds;
    if (ids !== "") {
      let searchIds = ids.split(",").map((x) => x.trim());

      let filteredPro = filteredProducts.map((x) => {
        if (searchIds.includes(x.productId)) x.check = true;
        return x;
      });
      // filteredPro.check = true
      console.log("item checked selected", filteredPro);

      // setfilteredProducts(filteredPro.filter((x) => x.check));
      setfilteredProducts(filteredPro);
    }
    //  1,39,28,6,153,187,192,205,206,210,211,231,232,258,269,270,279,296,317,144
  };
  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center justify-evenly">
        <div className="flex flex-col m-2 justify-between w-6/12">
          <TextField
            placeholder="103, 345, 920..."
            name="selectedIds"
            onChange={(e) => setselectedIds(e.target.value)}
            value={selectedIds}
          ></TextField>
          <div
            className="bg-green-400 p-5 bx bx-printer w-full cursor-pointer text-white text-center hover:bg-blue-700 hover:font-extrabold"
            onClick={() => {
              selectIds();
            }}
          >
            Select ID's
          </div>
        </div>
        <div className="flex flex-col m-2 justify-between w-6/12">
          <TextField
            placeholder="123, 345, 920..."
            name="unselectedIds"
            onChange={(e) => setunselectedIds(e.target.value)}
            value={unselectedIds}
          ></TextField>
          <div
            className="bg-red-400  p-5 bx bx-printer w-full cursor-pointer text-white text-center hover:bg-blue-700 hover:font-extrabold"
            onClick={() => {
              unselectIds();
            }}
          >
            Un Select ID's
          </div>
        </div>
      </div>
      <div className="flex items-center m-2 justify-between">
        <div
          className="bg-blue-400 p-5 bx bx-printer w-3/12 cursor-pointer text-white text-center hover:bg-blue-700 hover:font-extrabold"
          onClick={() => {
            printSelectedItems();
          }}
        >
          Print
        </div>
        <div
          className="bg-blue-400 p-5 bx bx-printer w-3/12 cursor-pointer text-white text-center hover:bg-blue-700 hover:font-extrabold"
          onClick={() => {
            setLabelPageSize("landscape", "10px");
            printLabel();
          }}
        >
          print Label
        </div>
      </div>
 

 
      <div className="p-4" ref={componentRef}>
        <div className="flex flex-col w-full pl-4">
          <div className="font-extrabold text-sm flex justify-center">
            SHIMLA GEM REPORTS{" "}
          </div>
          <div className="font-extrabold text-xs flex justify-center">
            STOCK TAKING OUT LIST - ({filteredProducts.length})
          </div>
          <div className="m-2">{new Date().toDateString()}</div>
          <hr></hr>
          <Table
            //   limit="10"
            headData={allItemTableHead}
            renderHead={(item, index) => renderHead(item, index)}
            bodyData={filteredProducts}
            renderBody={(item, index) => finalRenderBody(item, index)}
          ></Table>

          <div className="flex flex-col w-full justify-end items-end my-4">
            <div className="flex w-4/12 text-sm font-extrabold justify-between items-end my-1">
              <div>Total Purchase Amount : </div>
              <div>{Number(sumOfBuyPrice).toLocaleString()} LKR</div>
            </div>
            <div className="flex w-4/12 text-sm font-extrabold justify-between items-end my-1">
              <div>Total Piece Count : </div>
              <div>{sumOfPiece}</div>
            </div>
            <div className="flex w-4/12 text-sm font-extrabold justify-between items-end my-1">
              <div>Total Carat Count : </div>
              <div>{sumOfCarat.toFixed(3)}</div>
            </div>
          </div>
        </div>
      </div>

      <section ref={labelPrintRef}>
        {filteredProducts
          .filter((x) => x.check)
          .map((y, i, arr) => {
            // console.log("Main index : ", i , i % 3 === 0)
            return (
              <>
                {i % 84 === 0 && (
                  <div
                    style={{
                      width: "20cm",
                      maxHeight: "22.4cm",
                      marginBottom: "9cm",
                      marginTop: "1mm",
                    }}
                    className="pageBreak flex flex-wrap"
                  >
                    {filteredProducts
                      .filter((x) => x.check)
                      .slice(i, i + 84)
                      .map((x) => {
                        // console.log(x)
                        return (
                          <LabelPrintingLayout
                            buyPrice={x.buyPrice}
                            treatment_type={x.treatment_type}
                            key={x?.no}
                            no={x?.no}
                            weight={x.weight}
                            id={x.productId}
                            title={x.title}
                          />
                        );
                      })}
                  </div>
                )}
                {}
              </>
            );
          })}
      </section>
 

    </div>
  );
};

export default PrintAvailableItem;
